module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/yoai-4f7372861ba34b3e06bc78ac33d35d82.svg";